import React from "react";
import "./styles.scss";
export default function Loader({ children, loading }) {
  if (loading) {
    return (
      <div className="custom-loader-container">
        <span className="loader"></span>
      </div>
    );
  } else {
    return children;
  }
}
